interface IVisibleProps {
  if: boolean;
  children: any;
}

export default function Visible(props: IVisibleProps) {
  return (props.if && props.children) || null;
}
